import React from "react";
import classes from "./NumbersFlow.module.css";

function renderHighlightedText(text, highlights) {
  if (!text) return null;

  const validHighlights = Array.isArray(highlights)
    ? highlights.filter(Boolean)
    : [];

  if (!validHighlights.length) {
    return text;
  }

  const escapedHighlights = [...validHighlights]
    .sort((a, b) => b.length - a.length)
    .map((item) => item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  if (!escapedHighlights.length) {
    return text;
  }

  const regex = new RegExp(`(${escapedHighlights.join("|")})`, "gi");

  return text.split(regex).map((part, index) => {
    const isHighlighted = validHighlights.some(
      (highlight) => highlight.toLowerCase() === part.toLowerCase(),
    );

    return isHighlighted ? (
      <span key={index} className={classes.highlight}>
        {part}
      </span>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    );
  });
}

export default function NumbersFlow({
  eyebrow = "",
  heading = "",
  highlights = [],
  intro = "",
  steps = [],
}) {
  const hasSteps = Array.isArray(steps) && steps.length > 0;

  return (
    <section className={classes.section}>
      <div className={classes.container}>
        {(eyebrow || heading || intro) && (
          <header className={classes.header}>
            {eyebrow && (
              <span className={classes.eyebrow}>
                {eyebrow}
              </span>
            )}

            {heading && (
              <h2 className={classes.heading}>
                {renderHighlightedText(heading, highlights)}
              </h2>
            )}

            {intro && (
              <p className={classes.intro}>
                {intro}
              </p>
            )}
          </header>
        )}

        {hasSteps && (
          <div className={classes.process}>
            {steps.map((step, index) => {
              const isLast = index === steps.length - 1;

              return (
                <React.Fragment key={step.id || step.number || index}>
                  <article className={classes.step}>
                    <div className={classes.stepTop}>
                      {step.number && (
                        <span className={classes.number} aria-hidden="true">
                          {step.number}
                        </span>
                      )}

                      {step.icon && (
                        <div className={classes.icon} aria-hidden="true">
                          {step.icon}
                        </div>
                      )}
                    </div>

                    {(step.title || step.description) && (
                      <div className={classes.content}>
                        {step.title && <h3>{step.title}</h3>}

                        {step.description && <p>{step.description}</p>}
                      </div>
                    )}
                  </article>

                  {!isLast && (
                    <span className={classes.connector} aria-hidden="true" />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
